import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, formatApiError } from "../lib/api";
import { toast } from "sonner";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        if (localStorage.getItem("sp_token")) {
          const { data } = await api.get("/auth/me");
          setUser(data);
        }
      } catch (_) {
        setAuthToken(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAuthToken(data.access_token);
      setUser(data.user);
      toast.success(`Welcome back, ${data.user.name}`);
      return null;
    } catch (e) {
      const msg = formatApiError(e, "Login failed");
      toast.error(msg);
      return msg;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_e) { /* ignore */ }
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
